import { Component, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { ModalService} from 'src/app/core/services';
import {
  LaneService, RegulationService, SpotService,
  ViewViolationService, ViolationReportService, ViolationService
} from '../../core/services';
import { Category, ComponentModal, Lane, Reason, Regulation, Spot, Violation } from '../../core/models';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { QuarantineStatus } from '../../core/models/Quarantine';
import { LoteInfoComponent } from '../lote-info/lote-info.component';
import { DetailsViolationComponent } from '../details-violation/details.component';

@Component({
  selector: 'app-view-select-list',
  templateUrl: './violation-report-details-modal.component.html',
  styleUrls: ['./violation-report-details-modal.component.sass']
})
export class ViolationReportDetailsModalComponent extends BaseModal  implements OnInit {
  public loading = false;
  public initialState: any;
  public params: any = {};
  public paginationParams: any = {};
  public violations: Violation[] = [];
  public contractDataViolationsSub: Subscription;
  public violationsStepsResource: any[] = [];
  public violationsSteps: any[] = [
    'validateLane',
    'validateCalibration',
    'validateSpeed',
    'validateFiles',
    'validateExemptPeriod',
    'validateViolationLimit',
    'verifyValid',
    'verifyInvalid',
    'triage',
    'typing',
    'verify',
    'validate',
    'lotAttribution',
    'internalAudit',
    'revision',
    'filter',
    'done',
    'quarantine',
    'verifyCFTV',
    'validateCFTV',
    'monitoringCFTV',
  ];
  public quarantineStatusI18n = [];
  public quarantineStatus = Object.values(QuarantineStatus);
  public regulations: Regulation[] = [];
  public lanes: Lane[] = [];
  public spots: Spot[] = [];
  public reasons: Reason[] = [];
  public categories: Category[] = [];
  public spotInfo: string;
  public laneInfo: string;
  public hideLane: boolean;
  public hideSpot: boolean;

  constructor(
    public modalService: ModalService,
    public violationService: ViolationService,
    private violationReportService: ViolationReportService,
    private viewViolationService: ViewViolationService,
    private spotService: SpotService,
    private laneService: LaneService,
    private regulationService: RegulationService
  ) {
    super(modalService);
  }

  get isValid(): boolean {
      throw new Error('Method not implemented.');
  }

  get lastState(): any {
      throw new Error('Method not implemented.');
  }

  onAllSubmited(): Promise<any> {
      throw new Error('Method not implemented.');
  }

  async ngOnInit() {
    this.loading = true;
    this.params = this.initialState?.params;
    const { spotCode: _spotCode, ...queryParams } = this.params ?? {};
    this.paginationParams = queryParams;
    await this.getSpotInfo();
    await this.getLaneInfo();
    await this.getRegulations();
    this.loading = false;
  }

  setViolations(list) {
    this.violations = list.data;
  }

  async getRegulations() {
    const response = await this.regulationService.getAll();
    this.regulations = response;
  }

  async getSpotInfo() {
    if (this.params?.spotCode === undefined) {
      this.hideSpot = true;
      return;
    }
    const response = await this.spotService.list({ code: this.params?.spotCode});
    this.spotInfo = `${response.result[0]?.code} - ${response.result[0]?.address.street}`;
  }

  async getLaneInfo() {
    if (this.params['laneCode[in]'] === undefined) {
      this.hideLane = true;
      return;
    }
    const response = await this.laneService.list({ code: this.params['laneCode[in]'].replace('[', '').replace(']', '')});
    this.laneInfo = `${response.result[0]?.code} - ${response.result[0]?.prettyNames}`;
    if (response.result[0]?.code === undefined) {
      this.hideLane = true;
    }
  }

  getRegulationCode(regulation) {
    return this.regulations.filter(item => item.id === regulation).map(item => item.code).shift();
  }

  getRegulationInfo(regulation) {
    if (this.regulations.length > 0) {
      const regulationInfo = this.regulations.filter(item => item.id === regulation).shift();
      return regulationInfo?.description;
    }
  }

  getAuthorInfo(violation) {
    let item;
    if (violation) {
      if (this.getNormalizedHistory(violation)[0].id === 'lotAttribution') {
        item = this.getNormalizedHistory(violation)[1];
      } else {
        item = this.getNormalizedHistory(violation).shift();
      }
    }
    return item?.authorName || null;
  }

  getHistories(history) {
    return this.getNormalizedHistory(history);
  }

  getStatusQuarantine(quarantineReason = null) {
    if (this.quarantineStatusI18n.length === 0 || quarantineReason == null) {
      return;
    }
    return this.quarantineStatusI18n.find(q => q.id === quarantineReason).value;
  }

  async showHistory(lotId) {
    await this.modalService.show(new ComponentModal(LoteInfoComponent, { lotId, contractId: this.params?.contractId }))
      .catch((error) => console.log(error));
  }

  async showDetails(violation) {
    const data = {
      regulations: this.regulations,
      lanes: this.lanes,
      categories: this.categories
    };

    this.viewViolationService.emitDataViewContractViolation(data);

    await this.modalService.show(new ComponentModal(DetailsViolationComponent, { violation }))
      .catch((error) => console.log(error));
  }

  setResources(value) {
    this.violationsStepsResource = value;
  }

  getNormalizedHistory(violationsHistory: []) {
    const resultNormalized = [];
    Object.entries(violationsHistory || []).map(item => {
      const id: string = item[0];
      const data: any = item[1];
      if (Array.isArray(data)) {
        data.map(itemInside => {
          const itemObj: any = {};
          const stepName = this.violationsStepsResource.filter(step => step.id === id).shift();
          itemObj.id = id;
          itemObj.title = stepName ? stepName.value : null;
          itemObj.date = itemInside.date;
          if (itemInside.authorName) {
            itemObj.authorName = itemInside.authorName;
          }
          resultNormalized.push(itemObj);
        });
      } else if (id === 'CFTV') {
        Object.entries(data || []).map(itemCFTV => {
          const dataCFTV: any = itemCFTV[1];
          dataCFTV.map(itemInside => {
            const idCFTV: string = itemCFTV[0];
            const itemObj: any = {};
            const stepName = this.violationsStepsResource.filter(step => step.id === idCFTV).shift();
            itemObj.id = idCFTV;
            itemObj.title = stepName ? stepName.value : null;
            itemObj.date = itemInside.date;
            if (itemInside.authorName) {
              itemObj.authorName = itemInside.authorName;
            }
            resultNormalized.push(itemObj);
          });
        });
      } else {
        const itemObj: any = {};
        itemObj.id = id;
        itemObj.title = this.violationsStepsResource.filter(step => step.id === id).shift()?.value;
        itemObj.date = data.date;
        if (data.authorName) {
          itemObj.authorName = data.authorName;
        }
        resultNormalized.push(itemObj);
      }
    });

    resultNormalized.sort((a, b) => +new Date(b.date) - +new Date(a.date));
    return resultNormalized;
  }
}
